// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cpr-pop-box .fix-center-main{background-color:#f5f5f5}", ""]);
// Exports
module.exports = exports;
